import { QueryClient } from '@tanstack/react-query'
import { createRouter } from '@tanstack/react-router'
import { setupRouterSsrQueryIntegration } from '@tanstack/react-router-ssr-query'
import { routeTree } from './routeTree.gen'

export const getRouter = () => {
  // Create QueryClient inside function (per-request in SSR)
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        // Avoid refetching immediately on client after SSR
        staleTime: 60 * 1000,
        gcTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        retry: 1,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      },
      mutations: {
        retry: 0,
      },
    },
  })

  const router = createRouter({
    routeTree,
    // Expose QueryClient via router context
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
  })

  // Setup automatic SSR integration
  setupRouterSsrQueryIntegration({
    router,
    queryClient,
    // Automatically wraps with QueryClientProvider
    wrapQueryClient: true,
  })

  return router
}
